
import { PowerBICourse } from './types';
import { POWERBI_FUNDAMENTALS_COURSE } from './fundamentals';
import { POWERBI_INTERMEDIATE_COURSE } from './intermediate';
import { POWERBI_PROFESSIONAL_COURSE } from './professional';

export const POWERBI_COURSES: PowerBICourse[] = [
  POWERBI_FUNDAMENTALS_COURSE,
  POWERBI_INTERMEDIATE_COURSE,
  POWERBI_PROFESSIONAL_COURSE
];

// Export individual courses for direct access
export { 
  POWERBI_FUNDAMENTALS_COURSE,
  POWERBI_INTERMEDIATE_COURSE,
  POWERBI_PROFESSIONAL_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const POWERBI_COURSE_METADATA = {
  totalCourses: POWERBI_COURSES.length,
  totalDuration: '48-54 hours',
  levels: ['fundamentals', 'intermediate', 'professional'],
  certificationAlignment: [
    'Microsoft Power BI Data Analyst Associate (PL-300)',
    'Microsoft Power Platform Functional Consultant Associate (PL-200)',
    'Microsoft Azure Data Engineer Associate (DP-203)'
  ],
  skillsPath: [
    'Power BI Desktop Navigation',
    'Data Connection & Transformation',
    'Basic Data Modeling',
    'Fundamental Visualizations',
    'Report Design & Sharing',
    'Advanced DAX Formulas',
    'Complex Data Models',
    'Custom Visualizations',
    'Row-Level Security',
    'Performance Optimization',
    'Enterprise Architecture',
    'Data Governance Framework',
    'Deployment Automation',
    'Advanced Analytics Integration',
    'Center of Excellence Leadership',
    'Multi-tenant Management'
  ]
};
